// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"52dedf65","453":"c01044c2"}[chunkId] + ".chunk.js";
};